import moment from 'moment';

export const compareDates = (a, b) => {
  return moment(a).valueOf() - moment(b).valueOf();
};

export const formatDate = (date, options = {}) => {
  const format = options ? options.format : undefined;

  return moment(date).format(format);
};

export const parseDate = (date, format) => {
  return moment(date, format).toDate();
};